export default __webpack_public_path__ + "static/media/q8_step2.dd49df33.png";